<template> 
  <div>
    <el-upload
      class="avatar-uploader"
      action="http://gongyiguanliapi.gongyishibao.com/upimg/upload"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload">
      <img v-if="imageUrl" :src="this.fileList[0].url" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>
<script>


  export default {
    name: 'singleUpload',
    props: {
      value: String
    },
    computed: {
      imageUrl() {
             if (this.imgurl != null && this.imgurl !== '') {
                       return this.imgurl;
                     } else {
                       return this.value;
                     }
            },
      imageName() {
        if (this.value != null && this.value !== '') {
          return this.value.substr(this.value.lastIndexOf("/") + 1);
        } else {
          return null;
        }
      },
      fileList() {
        return [{
          name: this.imageName,
          url: this.imageUrl
        }]
      },
      showFileList: {
        get: function () {
          return this.value !== null && this.value !== ''&& this.value!==undefined;
        },
        set: function (newValue) {
        }
      }
    },
    data() {
      return {
        imgurl:'',
        dataObj: {
          policy: '',
          signature: '',
          key: '',
          ossaccessKeyId: '',
          dir: '',
          host: '',
          // callback:'',
        },
        dialogVisible: false,
        useOss:false, //使用oss->true;使用MinIO->false
        ossUploadUrl:'http://macro-oss.oss-cn-shenzhen.aliyuncs.com',
        //minioUploadUrl:'http://localhost:8080/minio/upload',
        minioUploadUrl:'http://gongyiguanliapi.gongyishibao.com/upimg/upload',
      };
    },
    methods: {
      emitInput(val) {
        this.$emit('input', val)
      },
      handleRemove(file, fileList) {
        this.emitInput('');
      },
      handlePreview(file) {
        this.dialogVisible = true;
      },
      beforeUpload(file) {
        let _self = this;
        if(!this.useOss){
          //不使用oss不需要获取策略
          return true;
        }
        return new Promise((resolve, reject) => {
          policy().then(response => {
            _self.dataObj.policy = response.data.policy;
            _self.dataObj.signature = response.data.signature;
            _self.dataObj.ossaccessKeyId = response.data.accessKeyId;
            _self.dataObj.key = response.data.dir + '/${filename}';
            _self.dataObj.dir = response.data.dir;
            _self.dataObj.host = response.data.host;
            // _self.dataObj.callback = response.data.callback;
            resolve(true)
          }).catch(err => {
            console.log(err)
            reject(false)
          })
        })
      },
      handleUploadSuccess(res, file) {
        this.showFileList = true;
        this.fileList.pop();
        let url = this.dataObj.host + '/' + this.dataObj.dir + '/' + file.name;
        if(!this.useOss){
          //不使用oss直接获取图片路径
          url = res.data.url;
        }
        this.fileList.push({name: file.name, url: url});
        this.emitInput(this.fileList[0].url);
      },
      handleAvatarSuccess(res, file) {
              this.imgurl = res.data.url;
              this.emitInput(this.fileList[0].url);
               console.log(file);
            },
            beforeAvatarUpload(file) {
              const isJPG = file.type === 'image/jpeg';
              const isGIF = file.type === 'image/gif';
              const isPNG = file.type === 'image/png';
              const isBMP = file.type === 'image/bmp';
              const isLt2M = file.size / 1024 / 1024 < 3;
              if (!isJPG && !isGIF && !isPNG && !isBMP) {
                   this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
              }
              if (!isLt2M) {
                   this.$message.error('上传图片大小不能超过 3MB!');
              }
              return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
              }

    }
  }
</script>
<style>
#uplaod_div .el-upload-list--picture-card .el-upload-list__item{
  overflow: hidden;
      background-color: #fff;
      border: 0px;
      border-radius: 0px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
      height: 148px;
      margin: 0 8px 8px 0;
      display: inline-block;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 108px;
    height: 108px;
    line-height: 108px;
    text-align: center;
  }
  .avatar {
    width: 108px;
    height: 108px;
    display: block;
  }
</style>





// WEBPACK FOOTER //
// src/components/Upload/singleUpload.vue